import React, { Fragment, useState, useEffect, useRef } from 'react';
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import cx from "classnames";
import { populateFormDetails } from '../../Common/Appcommon';
import { durationWidgetList } from './Constants';

const PrimaryConfigForm = (props) => {
    let { control, errors, preFormData, preFormDetail, preFormList, preSummaryList, preSelectedSummary, preSelectedForm, onSearchClickRegister, onFormChange, chartType } = props;
    let [selectedForm, setSelectedForm] = useState(preSelectedForm);
    let [formData, setFormData] = useState(preFormData);
    let [selectedMetrics, setSelectedMetrics] = useState(preSelectedSummary);
    let [formList, setFormList] = useState(preFormList);
    let [formDetail, setFormDetail] = useState(preFormDetail);
    let [summaryFields, setSummaryFields] = useState([]);
    let [durationFields, setDurationFields] = useState([]);
    let [selectedDurationField, setSelectedDurationField] = useState({});
    let [selectedDurationType, setSelectedDurationType] = useState({});
    let [durationList, setDurationList] = useState(durationWidgetList);

    useEffect(() => {
        onSearchClickRegister(processSearchCallBacks);
    });

    const processSearchCallBacks = async (operation, customProps = {}) => {
        let saveFormData = {};
        saveFormData = formData;
        saveFormData['form'] = selectedForm;
        saveFormData['metric'] = selectedMetrics;
        return saveFormData;
    }

    useEffect(() => {
        setFormData(preFormData);
    }, [preFormData]);

    useEffect(() => {
        (async () => {
            if(preFormDetail.length > 0){
                setFormDetail(preFormDetail);
                await constructSummaryFieldList(preFormDetail);
            }
        })();

    }, [preFormDetail]);

    useEffect(() => {
        setSelectedForm(preSelectedForm);
    }, [preSelectedForm]);

    useEffect(() => {
        setSelectedMetrics(preSelectedSummary);
    }, [preSelectedSummary]);

    useEffect(() => {
        setFormList(preFormList);
    }, [preFormList]);

    /*useEffect(() => {
        setSummaryFields(preSummaryList);
    }, [preSummaryList]);*/

    const onInputChange = async (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }

    const handleTemplateChange = async (selectedValue, objName) => {
        if (objName === "selected_form") {
            setSelectedForm(selectedValue);
            let details = await populateFormDetails(selectedValue.value);
            await constructSummaryFieldList(details);
            await onFormChange(details);
        } else if (objName === "metric") {
            setSelectedMetrics(selectedValue);
        }
    }

    const constructSummaryFieldList = async (details, defaultSummary = "") => {
        let formInfo = details[0];
        let fieldDetails = details[1];
        let summaryList = [];
        summaryList.push({ value: "Record_Count", label: "Record Count" })
        let defaultSum = summaryList[0];
        fieldDetails.map((field, index) => {
            let fieldType = field[4];
            let fieldName = field[2];
            let fieldLabel = field[3];
            if (fieldType === "Currency") {
                let listvalue = { value: fieldName, label: "Sum of " + fieldLabel };
                if (fieldName === defaultSummary) {
                    defaultSum = listvalue;
                }
                summaryList.push(listvalue)
            }
        });
        setSelectedMetrics(defaultSum);
        setSummaryFields(summaryList);
    }

    return (
        <Fragment>
            <div className='input-section'>
                <label className={'workflow-lbl form-label'} htmlFor="db_name">Component Name</label>
                <Controller
                    name="db_name"
                    control={control}
                    rules={{ required: formData.db_name === undefined || formData.db_name === "" ? "Please provide component name" : false }}
                    render={({ field }) => {
                        return (
                            <input
                                {...field}
                                type="text"
                                name="db_name"
                                id="db_name"
                                value={formData.db_name}
                                autoComplete={"off"}
                                onChange={(e) => {
                                    field.onChange(e);
                                    onInputChange(e);
                                }}
                                className={`form-control ${errors.db_name ? 'is-invalid' : ''}`}
                            />
                        );
                    }}
                />
                {errors.db_name && <em className={`error invalid-feedback`}>{errors.db_name.message}</em>}
            </div>
            <div className={cx('input-section mt-3')}>
                <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="selected_form">Choose a Module</label>
                <Controller
                    name="selected_form"
                    control={control}
                    rules={{ required: Object.keys(selectedForm).length === 0 ? "Please choose a module" : false }}
                    render={({ field }) => {
                        return (
                            <Select
                                {...field}
                                placeholder={'---Choose One---'}
                                menuPlacement={"auto"}
                                menuPosition={'fixed'}
                                name="selected_form"
                                id="selected_form"
                                className={`basic-multi-select ${errors.selected_form ? 'is-invalid' : ''}`}
                                classNamePrefix="wa-select"
                                value={Object.keys(preFormList).length === 0 ? false : selectedForm}
                                onChange={e => {
                                    handleTemplateChange(e, 'selected_form');
                                    field.onChange(e);
                                }}
                                options={formList}
                            />
                        );
                    }}
                />
                {errors.selected_form && <em className={`error invalid-feedback`}>{errors.selected_form.message}</em>}

            </div>
            <div className={cx('input-section mt-3')}>
                <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="metric">KPI Metric</label>
                <Controller
                    name="metric"
                    control={control}
                    rules={{ required: Object.keys(selectedMetrics).length === 0 ? "Please choose a metric" : false }}
                    render={({ field }) => {
                        return (
                            <Select
                                {...field}
                                placeholder={'---Choose One---'}
                                menuPlacement={"auto"}
                                menuPosition={'fixed'}
                                name="metric"
                                id="metric"
                                className={`basic-multi-select ${errors.metric ? 'is-invalid' : ''}`}
                                classNamePrefix="wa-select"
                                value={Object.keys(summaryFields).length === 0 ? false : selectedMetrics}
                                onChange={e => {
                                    handleTemplateChange(e, 'metric');
                                    field.onChange(e);
                                }}
                                options={summaryFields}
                            />
                        );
                    }}
                />
                {errors.metric && <em className={`error invalid-feedback`}>{errors.metric.message}</em>}

            </div>
        </Fragment>
    );
}

export default React.memo(PrimaryConfigForm);